import { Background } from 'components/search/expedia/enums';
import { BackgroundState } from 'components/search/expedia/interfaces';

const initialBackgroundState: BackgroundState = {
  background: Background.BEACH,
};

export { initialBackgroundState };
